import Accordion from 'accordion-js';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  function openAccordionFromUL() {
    const containers = document.querySelectorAll(
      '.tools-container .accordion-container'
    );
    const params = new URLSearchParams(window.location.search);
    const letter = params.get('_listing_alphabet');
    const upperLetter = letter ? letter.toUpperCase() : null;

    if (containers.length > 0) {
      containers.forEach((container) => {
        let currentAccordion = null;
        const openedAccordions = [];

        // Get all the FacetWP alpha links and check which ones are available
        const alphaLinks = document.querySelectorAll('.facetwp-alpha');
        const availableLetters = new Set();

        alphaLinks.forEach((link) => {
          if (link.classList.contains('available')) {
            const dataId = link.getAttribute('data-id');
            availableLetters.add(dataId);
          }
        });

        // Disable accordions that don't have available letters
        container.querySelectorAll('.accordion__cont').forEach((accordion) => {
          if (accordion.classList.contains('accordion__item')) return; // Skip if it's an item, not a container
          const dataLetter = accordion.getAttribute('data-letter');
          accordion.classList.add('disabled');

          if (availableLetters.has(dataLetter)) {
            accordion.classList.remove('disabled');
          }
        });

        // Find the index of the accordion that matches the letter in the URL
        if (upperLetter) {
          currentAccordion = container.querySelector(
            `.accordion__cont[data-letter="${upperLetter}"]`
          );
        }

        if (currentAccordion) {
          const currentGroup = currentAccordion.parentNode;
          const currentIndex = Array.prototype.indexOf.call(
            currentGroup.children,
            currentAccordion
          );
          openedAccordions.push(currentIndex);
        }

        // Initialize Accordion.js with openOnInit indexes
        new Accordion(container, {
          duration: 400,
          showMultiple: false, // can open multiple if needed
          openOnInit: openedAccordions, // empty if no letter → all closed
        });

        // Scroll to the opened accordion
        if (upperLetter && currentAccordion) {
          setTimeout(() => {
            currentAccordion.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }, 200);
        }

        // Make sure all others are closed visually (in case openOnInit is empty)
        if (!upperLetter) {
          container.querySelectorAll('.accordion__cont').forEach((acc) => {
            acc.classList.remove('active');
            const panel = acc.querySelector('.ac-panel');
            if (panel) panel.style.display = 'none';
          });
        }
      });
    }
  }
  document.addEventListener('DOMContentLoaded', openAccordionFromUL);

  document.addEventListener('facetwp-loaded', openAccordionFromUL);
});
